import { Stack, TextField } from "@mui/material"

export function ConditionValueNumeric({ value, onChange, operator }) {
    const isBetween = operator === "between"
    const range = isBetween ? value || { min: 0, max: 0 } : null

    if (isBetween) {
        return (
            <Stack direction="row" spacing={1} alignItems="center">
                <TextField
                    type="number"
                    value={range.min ?? 0}
                    onChange={handleMinChange}
                    onWheel={(e) => e.target.blur()}
                    inputProps={{ step: "any" }}
                    placeholder="Min"
                    sx={{ flex: 1 }}
                />
                <TextField
                    type="number"
                    value={range.max ?? 0}
                    onChange={handleMaxChange}
                    onWheel={(e) => e.target.blur()}
                    inputProps={{ step: "any" }}
                    placeholder="Max"
                    sx={{ flex: 1 }}
                />
            </Stack>
        )
    }

    return (
        <TextField
            type="number"
            fullWidth
            value={value ?? 0}
            onChange={handleChange}
            onWheel={(e) => e.target.blur()}
            inputProps={{ step: "any" }}
        />
    )

    function handleMinChange(e) {
        onChange({ ...range, min: parseFloat(e.target.value) || 0 })
    }

    function handleMaxChange(e) {
        onChange({ ...range, max: parseFloat(e.target.value) || 0 })
    }

    function handleChange(e) {
        onChange(parseFloat(e.target.value) || 0)
    }
}
